import axios from 'axios';
import { AppLogo, ProfilePage, SettingsPage } from '../_global/components';
import securityService from '../_global/services/securityService';
import { getApiUrl } from '../utilities/configUtils';
import { Cookies } from '../utilities';

const mode = process.env.REACT_APP_MODE;

const isProd = mode === 'production';
// configs
const config = {
  // To display in the title of the browser or tabs
  applicationName: 'Odynn Admin Portal',
  // The theme to apply to the Material UI library
  theme: 'dark',
  // To render settings gear or not

  allowSettings: false,

  segmentKey: isProd
    ? 'D31kLVzM1JZrccVxnADYQEr2mC19msRw'
    : 'gen2DQM4uSNC7yoSEpHjKIdI3DGyTmTU',
  URL: getApiUrl(mode),
  pageSize: 15,
  dateFormat: 'MM-DD-YYYY',
  components: {
    // The component to render for the app logo on the side nav and login page
    appLogo: AppLogo,
    // The component to render when the profile page is accessed
    userProfile: ProfilePage,
    // The component to render when the settings page is accessed
    settings: SettingsPage
  },
  services: {
    // The service to call when the app loads to check if a user is signed in or not
    checkAuthentication: securityService.checkAuthentication,
    // The service to call when authenticating a user
    signInUser: securityService.login,
    // The service to call when signing a user out
    signOutUser: securityService.logout,
    // The service to call when accessing a user's profile
    getUserProfile: securityService.getProfile
  },
  utilities: {
    // A utility used to extract the user object from the authentication response
    extractUserFromAuthResponse: (res: any) => res,
    // A utility used to extract the user's account name from the user object
    extractAccountNameFromUser: (user: any) => user.email_address ?? '',
    // A utility used to extract the user's display name from the user object
    extractDisplayNameFromUser: (user: any) =>
      `${user.first_name ?? ''} ${user.last_name ?? ''}`
  },
  defaults: {
    user_region: 'US',
    default_password: 'Awayz01@'
  },
  endpoints: {
    users: {
      getByPage: '/account/awayz/users',
      getSingle: '/account/awayz/user',
      delete: '/account/awayz/user/delete',
      add: '/account/awayz/user/add',
      update: '/account/awayz/user/update',
      influencerLinks: '/account/users/getAllInfluencerLinks',
      getAwayzUserRequestLimit: '/account/request/user/limit',
      getBiltRequestLimit: '/bilt/request/limit',
      resetRequestLimit: '/account/requestLimit/reset',
      increaseRequestLimit: '/search/simulate',
      removeTestSearches: '/search/unsimulate'
    },
    banks: {
      getByPage: '/cards/getBanks/paginate',
      getSingle: '/cards/getBanks/single',
      delete: '/cards/bank/delete',
      add: '/cards/banks/add',
      update: '/cards/bank/update'
    },
    awards: {
      getByPage: '/rewards/getMainProgrammes',
      getSingle: '/rewards/getMainProgram',
      add: '/admin/awards/add',
      delete: '/admin/awards/delete',
      update: '/admin/awards/update',
      getMainPrograms: '/rewards/getMainProgrammes',
      getTransferPartners: '/rewards/getLinked/transferPrograms'
    },
    cards: {
      getByPage: '/cards/getAllCardsAdmin',
      getSingle: '/cards/getCard',
      add: '/admin/cards/add',
      delete: '/admin/card/delete',
      update: '/admin/card/update',
      updateSpendingCategories: '/admin/card/updateSpendingCategories',
      allSpendCate: '/goals/distinct/spendingAllCate',
      allBanks: '/cards/getBanks',
      allNetworks: '/cards/getNetworks'
    },
    roles: {
      getByPage: '/admin/roles',
      getSingle: '/admin/role',
      delete: '/admin/role/delete',
      add: '/admin/role/add',
      update: '/admin/role/update'
    },
    regions: {
      getRegions: '/userRegion'
    },
    reports: {
      getPartnerShareByCode: '/reporting/partners/revenueShare/byCode',
      getUserConversionsByCode: '/reporting/get/influencer/signups',
      getAllPartnerShareByCode: '/reporting/partners/revenueShare/all',
      getDailyPartnerShareByCode: '/reporting/partners/revenueShare/daily',
      getUserReports: '/reporting/partners/revenueShare/',
      fetchFileById: '/reporting/partners/revenueShare/fetchById/',
      deleteFileById: '/reporting/partners/revenueShare/deleteById/'
    },
    thirdParty: {
      dots: {
        totalpayouts: '/tp/dots/customer/totalpayouts',
        paymentLink: '/tp/dots/paymentLink',
        pendingUrls: '/tp/dots/partner/pending/urls'
      }
    },
    faqs: {
      getByPage: '/admin/faqs',
      getSingle: '/admin/faq',
      delete: '/admin/faq/delete',
      add: '/admin/faq/add',
      update: '/admin/faq/update'
    },
    Subscriptions: {
      subscription: '/account/subscription/'
    }
  }
};

export const axiosInstance = axios.create({
  baseURL: config.URL,
  timeout: 150000,
  withCredentials: true
});

axiosInstance.interceptors.request.use((config) => {
  let cookie: string | null =
    Cookies.getCookie('token') || localStorage.getItem('token');

  if (cookie && cookie!.indexOf('{') > -1) {
    cookie = cookie!.substring(cookie!.indexOf('{'));
    cookie = JSON.parse(cookie!).token;
  }

  // Add auth header to every request
  config.headers.Authorization = `Bearer ${cookie}`;
  config.responseType = 'json';
  return config;
});

export default config;
